import { Directive, ElementRef, Input, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This directive puts a css class in a sticky element to improve usability.
 * To understand how it works I highly recommend to read the article that was used to made this.
 * Here you can understand better the architecture:
 * https://developers.google.com/web/updates/2017/09/sticky-headers
 */
import * as ɵngcc0 from '@angular/core';
class StickyDirective {
    /**
     * @param {?} stickyElement
     */
    constructor(stickyElement) {
        this.stickyElement = stickyElement;
        this._debugMode = false;
        /**
         * Class to be added to the target element when becomes sticky
         */
        this.classWhenSticky = '';
        /**
         * zIndex value to set to the target element
         */
        this.zIndex = 10;
        /**
         * Top value to set to the target element
         */
        this.top = 0;
        // Import the Intersection Observer polyfill
        require('intersection-observer');
    }
    /**
     * * It must be a top container of the sticky element and of the element that will trigger the custom class on the sticky element.
     * * This should be the element with the scroll
     * If an string is provided, it must be the ID of the element.
     * @return {?}
     */
    get scrollContainer() {
        return this._scrollContainer;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set scrollContainer(value) {
        this.setHTMLElement('_scrollContainer', value);
    }
    /**
     * When the sticky element bypass this element the custom class will apply.
     * If an string is provided, it must be the ID of the element.
     * @return {?}
     */
    get triggerOn() {
        return this._triggerOn;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set triggerOn(value) {
        this.setHTMLElement('_triggerOn', value);
    }
    /**
     * When it's on, add some styles to the sentinel element
     * @return {?}
     */
    get debugMode() {
        return this._debugMode;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set debugMode(value) {
        this._debugMode = value;
        if (this._debugMode && !!this.sentinel) {
            this.sentinel.style.backgroundColor = 'rgba(255, 0, 0, 0.5)';
            this.sentinel.style.visibility = 'unset';
        }
        else if (!this._debugMode && !!this.sentinel) {
            this.sentinel.style.visibility = 'hidden';
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.makeSticky();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.putSentinel();
        this.setObserver();
    }
    /**
     * Transform if needed into HTMLElement a value given to be set in a property
     * @private
     * @param {?} prop
     * @param {?} value
     * @return {?}
     */
    setHTMLElement(prop, value) {
        if (typeof value === 'string') {
            this[prop] = document.getElementById(value);
        }
        else if (value instanceof ElementRef) {
            this[prop] = value.nativeElement;
        }
        else {
            this[prop] = value;
        }
    }
    /**
     * Make the main element sticky.
     * Put the necessary css to make it happen.
     * @private
     * @return {?}
     */
    makeSticky() {
        /** @type {?} */
        const nativeElement = this.stickyElement.nativeElement;
        this.setStylePropertyToElement(nativeElement, 'position', '-webkit-sticky');
        this.setStylePropertyToElement(nativeElement, 'position', 'sticky');
        this.setStylePropertyToElement(nativeElement, 'top', `${this.top}px`);
        this.setStylePropertyToElement(nativeElement, 'zIndex', this.zIndex.toString());
    }
    /**
     * @private
     * @param {?} nativeEl
     * @param {?} property
     * @param {?} value
     * @return {?}
     */
    setStylePropertyToElement(nativeEl, property, value) {
        nativeEl.style[property.toString()] = value;
    }
    /**
     * Start listening to the scroll event on the container element
     * @private
     * @return {?}
     */
    setObserver() {
        /** @type {?} */
        const observer = new IntersectionObserver((records) => this.onAppears(records), {
            threshold: [0],
            root: (/** @type {?} */ (this.scrollContainer))
        });
        // Add the bottom sentinels to each section and attach an observer.
        observer.observe(this.sentinel);
    }
    /**
     * Add/Remove class to the target element when the sentinel element disappear/appear
     * @private
     * @param {?} records
     * @return {?}
     */
    onAppears(records) {
        for (const record of records) {
            /** @type {?} */
            const nativeElement = this.stickyElement.nativeElement;
            /** @type {?} */
            const targetInfo = record.boundingClientRect;
            /** @type {?} */
            const rootBoundsInfo = record.rootBounds;
            if (targetInfo.bottom < rootBoundsInfo.top) {
                nativeElement.classList.add(this.classWhenSticky);
            }
            if (targetInfo.bottom >= rootBoundsInfo.top &&
                targetInfo.bottom < rootBoundsInfo.bottom) {
                nativeElement.classList.remove(this.classWhenSticky);
            }
        }
    }
    /**
     * Generates the sentinel element with the necessary styles
     * @private
     * @return {?}
     */
    generateSentinelElement() {
        /** @type {?} */
        const sentinelEl = document.createElement('div');
        sentinelEl.style.height = '50px';
        sentinelEl.style.width = '100%';
        sentinelEl.style.position = 'absolute';
        sentinelEl.style.visibility = 'hidden';
        if (this._debugMode) {
            sentinelEl.style.backgroundColor = 'rgba(255, 0, 0, 0.5)';
            sentinelEl.style.visibility = 'unset';
        }
        return sentinelEl;
    }
    /**
     * Add the sentinel element as the first child of the triggerOn element
     * @private
     * @return {?}
     */
    putSentinel() {
        /** @type {?} */
        const sentinel = this.generateSentinelElement();
        this.sentinel = (/** @type {?} */ (((/** @type {?} */ (this.triggerOn))).insertAdjacentElement('afterbegin', sentinel)));
    }
}
StickyDirective.ɵfac = function StickyDirective_Factory(t) { return new (t || StickyDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
StickyDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: StickyDirective, selectors: [["", "ngxSticky", ""]], inputs: { classWhenSticky: "classWhenSticky", zIndex: "zIndex", top: "top", scrollContainer: "scrollContainer", triggerOn: "triggerOn", debugMode: "debugMode" } });
/** @nocollapse */
StickyDirective.ctorParameters = () => [
    { type: ElementRef }
];
StickyDirective.propDecorators = {
    scrollContainer: [{ type: Input }],
    triggerOn: [{ type: Input }],
    debugMode: [{ type: Input }],
    classWhenSticky: [{ type: Input }],
    zIndex: [{ type: Input }],
    top: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StickyDirective, [{
        type: Directive,
        args: [{
                selector: '[ngxSticky]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { classWhenSticky: [{
            type: Input
        }], zIndex: [{
            type: Input
        }], top: [{
            type: Input
        }], scrollContainer: [{
            type: Input
        }], triggerOn: [{
            type: Input
        }], debugMode: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StickyDirectiveModule {
}
StickyDirectiveModule.ɵfac = function StickyDirectiveModule_Factory(t) { return new (t || StickyDirectiveModule)(); };
StickyDirectiveModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: StickyDirectiveModule });
StickyDirectiveModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StickyDirectiveModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [StickyDirective],
                exports: [StickyDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(StickyDirectiveModule, { declarations: [StickyDirective], exports: [StickyDirective] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { StickyDirective, StickyDirectiveModule };

